/**
 * MiniBar — 常駐播放條（設計 v2 §4 **C10**；住 app shell `.shell__dock`）
 *
 * 來源：`.coappery/tasks/J-ui-cosingery/design/components.jsx` C10（UI v2 **步 8**）
 *   · 撳歌名 → 開全螢幕播放器（C11）；▶／⏸／⏭ 即時控制
 *   · ⚠️ **無歌時唔渲染**（設計指定）
 */
import { useTranslation } from 'react-i18next';
import { usePlayer } from './PlayerContext';
import { Icons } from '../components/Icons';

export default function MiniBar({ onOpen }: { onOpen: () => void }) {
  const { t } = useTranslation();
  const p = usePlayer();
  if (!p.track) return null;
  const total = (p.durationMs ?? 0) / 1000;
  const ratio = total > 0 ? Math.min(1, p.positionMs / 1000 / total) : 0;

  return (
    <div className="minibar">
      <div className="minibar__progress" aria-hidden="true">
        <i style={{ width: `${ratio * 100}%` }} />
      </div>
      <button type="button" className="minibar__info" onClick={onOpen} aria-label={t('player_open_aria')}>
        <span className="minibar__title">{p.track.title}</span>
        <span className="minibar__sub">{t('player_now_playing')}</span>
      </button>
      <button
        type="button"
        className="icon-btn"
        onClick={p.toggle}
        aria-label={p.playing ? t('player_pause') : t('player_play')}
      >
        {p.playing ? <Icons.Pause /> : <Icons.Play />}
      </button>
      <button type="button" className="icon-btn" onClick={p.next} aria-label={t('player_next')}>
        <Icons.Next />
      </button>
    </div>
  );
}
